import { useEffect, useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { IGetMaskOptionsResponse, IProductEntity } from "../../../Services/api/products/products.interface";


import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from 'yup';
import { IArtEntity } from "../../../Services/api/arts/arts.interface";

import { EStoreType, IPayloadOrderReplacement, IPayloadUpdateOrderReplacement, IProductOrderReplacement } from "../../../Services/api/orders-replacement/orders-replacement.interface";
import { CreateOrdersReplacementUseCase } from "../../../Usecase/OrdersReplacement/create-orders-replacement-usecase";
import { FindKeyWithPrefix } from "../../../utils/findKeyWithPrefix";
// import { UpdateArtsUseCase } from "../../../Usecase/Arts/update-arts-usecase";
import { useTheme } from "@mui/material";
import { ListCustomersUseCase } from "../../../Usecase/Customers/list-customers-usecase";
import { ShowOrdersReplacementUseCase } from "../../../Usecase/OrdersReplacement/show-orders-replacement-usecase";
import { UpdateOrdersReplacementUseCase } from "../../../Usecase/OrdersReplacement/update-orders-replacement-usecase";
import { ListProductUseCase } from "../../../Usecase/Products/list-product-usecase";

import { GetMaskProductOptionsUseCase } from "../../../Usecase/Products/get-mask-product-options-usecase";
import { normalizeDateTimeZoneInString, normalizeDateToInputCalendar, normalizeStringData } from "../../../utils/chronos";

interface IUseCreateArtsProps {
    
  listCustomersUseCase: ListCustomersUseCase
  listProductsUseCase: ListProductUseCase
  createOrdersReplacementUseCase: CreateOrdersReplacementUseCase
  showOrdersReplacementUseCase: ShowOrdersReplacementUseCase
  updateOrdersReplacementUseCase: UpdateOrdersReplacementUseCase
  getMaskProductOptionsUseCase: GetMaskProductOptionsUseCase
    
    //  updateArtsUseCase: UpdateArtsUseCase
}

const CreateArtSchemaValidation = Yup.object().shape({
    url: Yup.string().required('URL da arte é obrigatório'),
  });


interface IArtProps {
	url: string
  [key: string]: string
	
}

export function useCreateReplacementOrder({ createOrdersReplacementUseCase, showOrdersReplacementUseCase, updateOrdersReplacementUseCase, getMaskProductOptionsUseCase }: IUseCreateArtsProps){
    const [loading, setLoading] = useState(false)
    const [isDataLoaded, setIsDataLoaded] = useState(false)
    const [data, setData] = useState<IArtEntity>()
    const [showBrandsModal, setShowBrandsModal] = useState(false)
    const [showProductsModal, setShowProductsModal] = useState(false)

    const [indexSelected, setIndexSelected] = useState<number | undefined>(undefined)

    const [productsSelected, setProducstSelected] = useState<IProductOrderReplacement[]>([])
    const [productToDestroy, setProductToDestroy] = useState<IProductOrderReplacement | undefined>(undefined)
    const [dueDate, setDueDate] = useState<string | undefined>(undefined)
    const [maskOptions, setMaskOptions] = useState<IGetMaskOptionsResponse>({
      types: [],
      families: [],
      volumetries: [],
      materials: [],
      complements: [],
      versions: [],
      brands: []
    })

    const params = useParams()
    const theme = useTheme()

    
    const navigate = useNavigate()
    const { handleSubmit, register, control, formState, setValue, unregister, watch } = useForm<IArtProps>();

      const { errors } =  formState

    const { showToast } =  useToast()

    const brandValue = watch('brand')

    const brandSelected = useMemo(() => {
      const find = maskOptions?.brands?.find((item) => item.value === brandValue)

      return find
    },[brandValue, maskOptions])

    const handleGetMaskProductOptions = async () => {
        
      try {
        setLoading(true)
       
        const showResult = await getMaskProductOptionsUseCase.handle();

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          
          return;
        }

       const options = showResult.getValue()

       if(options){ 
        const { brands } = options;
        
        setMaskOptions(options)
       
       }

      
      } catch (error) {
        console.log("error handleShowProduct function: ", error)
      } finally {
        setLoading(false);
      }
    };

  

    const showOrderReplacement = async (replacementId: string) => {
      try {
        setLoading(true)
        
        const showResult = await showOrdersReplacementUseCase.handle(replacementId);

        if (showResult.isFailure) {
          showToast(String(showResult?.error?.error), 'error');
          return;
        }

        const replacementOrder = showResult.getValue()
   

        if(replacementOrder){
          const find = maskOptions?.brands?.find((item) => replacementOrder.brand === item.label)
          console.log('find brand:', find)
          if(find){
            setValue('brand', find.value)
          }

          setValue('store', replacementOrder.store)

          const normalizeProducts = replacementOrder.products.map((item) => {
            console.log('product item:', item)
            return {
              id: item.product.id,
              replacementOrderProductId: item.id,
              quantity: item.totalQuantity || 0,
              name: item.product.name,
              internalName: item.product.internalName,
              hcpCurrentFlow: item.hcpCurrentFlow ?? null,
              hcpCurrentFlowStatusId: item.hcpCurrentFlowStatusId ?? null,
              hcpCurrentFlowCode: item.hcpCurrentFlowCode ?? null,
              hcpCurrentFlowStatusSequence: item.hcpCurrentFlowStatusSequence ?? null,
              hcpCurrentFlowDisplayCode: item.hcpCurrentFlowDisplayCode ?? null,
              hcpCurrentFlowStatusName: item.hcpCurrentFlowStatusName ?? null,
              hcpCurrentFlowStartedAt: item.hcpCurrentFlowStartedAt ?? null,
              hcpCurrentFlowDeadline: item.hcpCurrentFlowDeadline ?? null,
              hcpFinished: item.hcpFinished ?? null,
              hcpPreServiceOrderId: item.hcpPreServiceOrderId ?? null
            }
          })
          console.log('normalized products:', normalizeProducts)
          setProducstSelected(normalizeProducts)

          // Set quantities for each product
          replacementOrder.products.forEach((item) => {
            const fieldName = `order-qtd-${item.product.id}`
            console.log('setting field:', fieldName, 'value:', item.totalQuantity)
            setValue(fieldName, String(item.totalQuantity))
          })

          // Set due date
          if(replacementOrder?.dueDate){
            console.log('original dueDate:', replacementOrder.dueDate)
            // Criar a data com o timezone correto
            // const [year, month, day] = replacementOrder.dueDate.split('T')[0].split('-')
            // const parsedDate = new Date(Number(year), Number(month) - 1, Number(day))
            // console.log('parsed dueDate:', parsedDate)
            const date = normalizeDateTimeZoneInString(String(replacementOrder.dueDate))
            console.log('date final: ', date)            
            setDueDate(normalizeDateToInputCalendar(date))
            // console.log('dueDate after set:', dueDate)
          }

          // Set observations
          if(replacementOrder?.observations){
            setValue('observations', replacementOrder.observations)
          }
        }
      } catch (error) {
        console.log("error in showOrderReplacement:", error)
        showToast('Erro ao carregar pedido', 'error')
      } finally {
        setLoading(false);
      }
    };

      const productsSelectedWithIndex = useMemo(() => productsSelected.map((product, index) => ({
        ...product,
        index
      })), [productsSelected])


    const handleAction: SubmitHandler<IArtProps> = async (values) => {
        
        try {
          setLoading(true)

          if(!productsSelected?.length){
            showToast('Selecione pelo menos um produto', 'error');
            setLoading(false)
            return;
          }

          if(!brandSelected?.value){
            showToast('Selecione a Marca', 'error');
            setLoading(false)
            return;
          }

          if(!values?.store){
            showToast('Selecione a Loja', 'error');
            setLoading(false)
            return;
          }

          const quantityValues = FindKeyWithPrefix(values, 'order-qtd-')
          
          const payloadCreate: IPayloadOrderReplacement  = {
            store: values?.store as EStoreType,
            brand: brandSelected.label,
            // dueDate: dueDate ? format(dueDate, 'yyyy-MM-dd') : '',
            dueDate: dueDate ? normalizeStringData(dueDate) : '',
            observations: values.observations || '',
            products: productsSelectedWithIndex.map((product) => {
              const quantityItem = quantityValues.find((item: { key: string; value: string }) => item.key === `order-qtd-${product.id}`)
              return {
                id: product.id,
                quantity: Number(quantityItem?.value || 0)
              }
            }),
            originalPrice: '0',
            finalPrice: '0',
          }

          const payloadUpdate: IPayloadUpdateOrderReplacement = {
            id: String(params.id),
            ...payloadCreate
          }

          console.log("payload: ", payloadCreate)

          const verifyAllProducts = payloadCreate.products.every((product) => Number(product.quantity) > 0)

          if(!verifyAllProducts){
            showToast('Preencha a quantidade de todos os produtos', 'error');
            setLoading(false)
            return;
          }

        
          const result = params.id ? await updateOrdersReplacementUseCase.handle(payloadUpdate) :  await createOrdersReplacementUseCase.handle(payloadCreate);

          if (result.isFailure) {
            
            showToast(String(result?.error?.error), 'error');
            return;
          }

          showToast(params.id ? 'Pedido Atualizado' : 'Pedido Cadastrado', 'success')
          navigate('/orders-replacement-list');

        } catch (error) {
            console.log("error: ", error)
            showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
          // toast({
          //   position: 'top-right',
          //   render: () => <ToastCustom type='fail' title='Erro' description={error.response?.data?.error ?? 'Erro ao logar. Por favor, tente novamente'} />,
          // });
        } finally {
          setLoading(false);
        }
      };

  
    // Carrega as opções de máscara primeiro
    useEffect(() => {
      handleGetMaskProductOptions()
    }, [])

    // Depois que as opções forem carregadas, carrega os dados do pedido se houver um ID
    useEffect(() => {
      const loadInitialData = async () => {
        // Se houver um ID nos params, aguarda o carregamento das opções de máscara
        if(params.id && maskOptions.brands.length > 0){
          await showOrderReplacement(params.id)
        }
        // Define que os dados foram carregados (ou não há dados para carregar)
        setIsDataLoaded(true)
      }

      // Se não houver ID, marca como carregado imediatamente quando as opções estiverem disponíveis
      if(!params.id && maskOptions.brands.length > 0){
        setIsDataLoaded(true)
      } else {
        loadInitialData()
      }
    }, [params.id, maskOptions.brands.length])

    // const handleSelectCustomer = (customer: ICustomerEntity) => {
    //   setBrandSelected(customer)
    //   setShowBrandsModal(false)
    // }

    const handleSelectProduct = (product: IProductEntity) => {
      console.log("product selecionado: ", product)
      if(!product?.approvedArtId){
        showToast('Produto não contém arte aprovada. Não é possível adicionar ao pedido', 'error');
        return;
      }
      const productExists = productsSelected.some(p => p.id === product.id);
      
      if (productExists) {
        showToast('Produto já adicionado', 'error');
        return;
      }

      const payload : IProductOrderReplacement = {
        id: product.id,
        quantity: 0,
        name: product.name,
        artId: '',
        artLink: '',
        internalName: product.internalName || ''
      }
      setProducstSelected(prev => [...prev, payload])
      setShowProductsModal(false)
    }


    const handleDestroyProduct = () => {
    
      const newGroup = [...productsSelected]
      newGroup.splice(Number(productToDestroy?.index), 1)
      unregister(`order-qtd-${productToDestroy?.id}`)
      setProducstSelected(newGroup)
      setProductToDestroy(undefined)
    }

   



    return {
        loading,
        isDataLoaded,
        handleSubmit,
        handleAction,
        register,
        setShowBrandsModal,
        showBrandsModal,
        errors,
        data,
        brandSelected,
        handleSelectProduct,
        setShowProductsModal,
        showProductsModal,
        productsSelected,
        setIndexSelected,
        indexSelected,
        productsSelectedWithIndex,
        setProductToDestroy,
        productToDestroy,
        handleDestroyProduct,
        navigate,
        theme,
        control,
        dueDate,
        setDueDate,
        maskOptions 

        
        
    }
}
